var webFontLoader = {
  google: {
    families: ['Lato:400,700,900']
  }
};
export default webFontLoader;